<template>
  <div class="news-detail">
    <section class="news-detail-header">
      <div class="news-detail-bg">
        <img :src="newsDetail.image" :alt="newsDetail.title">
        <div class="news-detail-overlay"></div>
      </div>
      <div class="news-detail-title">
        <div class="news-detail-category-badge">{{ newsDetail.category }}</div>
        <h1 class="fade-in-up">{{ newsDetail.title }}</h1>
        <div class="news-detail-meta fade-in-up delay-2">
          <span class="meta-item">
            <i class="el-icon-time"></i>
            {{ newsDetail.date }}
          </span>
          <span class="meta-divider">|</span>
          <span class="meta-item">
            <i class="el-icon-user"></i>
            {{ newsDetail.author }}
          </span>
          <span class="meta-divider">|</span>
          <span class="meta-item">
            <i class="el-icon-view"></i>
            已阅读
          </span>
        </div>
      </div>
    </section>

    <section class="news-detail-content section-padding">
      <div class="container">
        <div class="news-detail-layout">
          <article class="news-detail-article">
            <div class="news-detail-image" data-aos="zoom-in">
              <img :src="newsDetail.image" :alt="newsDetail.title">
            </div>
            <div class="news-detail-text" data-aos="fade-up" data-aos-delay="100">
              <p class="first-paragraph">{{ newsDetail.content }}</p>
              <p class="news-detail-paragraph">
                在培训过程中，公司专家团队针对盐源县的实际情况，结合国家和地方的政策导向，为参会人员提供了详细的项目谋划指导。培训内容涵盖项目可行性研究报告编制要点、资金申报流程、项目包装策略等方面。
              </p>
              <p class="news-detail-paragraph">
                此次培训得到了盐源县领导和相关部门的高度认可，参会人员纷纷表示收获颇丰，对今后的项目工作有了更清晰的认识和规划。
              </p>
              <blockquote class="news-detail-quote">
                <i class="el-icon-chat-dot-round quote-icon"></i>
                "此次培训非常及时，内容丰富，实用性强，为我们今后的项目工作指明了方向。"
                <span class="quote-author">——盐源县相关负责人</span>
              </blockquote>
              <p class="news-detail-paragraph">
               新恒丰集团将继续发挥专业优势，为各地政府和企业提供高质量的咨询服务，助力区域经济社会高质量发展。
              </p>
            </div>

            <div class="news-detail-tags" data-aos="fade-up" data-aos-delay="200">
              <span class="tags-label">相关标签：</span>
              <span class="tag-item" v-for="tag in ['项目培训', '盐源县', '咨询服务']" :key="tag">{{ tag }}</span>
            </div>

            <div class="news-detail-actions" data-aos="fade-up" data-aos-delay="300">
              <div class="share-section">
                <span class="share-label">分享到：</span>
                <button class="share-btn" title="分享到微信">
                  <i class="el-icon-wechat"></i>
                </button>
                <button class="share-btn" title="分享到微博">
                  <i class="el-icon-sina-weibo"></i>
                </button>
                <button class="share-btn" title="分享到QQ">
                  <i class="el-icon-chat-line-square"></i>
                </button>
                <button class="share-btn" title="复制链接">
                  <i class="el-icon-link"></i>
                </button>
              </div>
            </div>
          </article>

          <aside class="news-detail-sidebar">
            <div class="sidebar-section" data-aos="fade-left">
              <h3>相关新闻</h3>
              <ul class="related-news-list">
                <li v-for="news in relatedNews" :key="news.id">
                  <router-link :to="`/news/detail/${news.id}`">
                    <img :src="news.image" :alt="news.title" data-aos="zoom-in">
                    <div class="related-news-info">
                      <span class="related-news-title">{{ news.title }}</span>
                      <span class="related-news-date">
                        <i class="el-icon-time"></i>
                        {{ news.date }}
                      </span>
                    </div>
                  </router-link>
                </li>
              </ul>
            </div>

            <div class="sidebar-section contact-section" data-aos="fade-left" data-aos-delay="150">
              <h3>联系我们</h3>
              <div class="contact-item">
                <i class="el-icon-phone"></i>
                <span>010-88888888</span>
              </div>
              <div class="contact-item">
                <i class="el-icon-mail"></i>
                <span>contact@hongtai.com</span>
              </div>
              <router-link to="/contact" class="contact-btn">联系我们</router-link>
            </div>
          </aside>
        </div>

        <div class="news-detail-navigation" data-aos="fade-up">
          <div class="nav-prev">
            <span class="nav-label">
              <i class="el-icon-arrow-left"></i>
              上一篇
            </span>
            <router-link to="/news/detail/2">公司开展"全过程工程咨询风险防范"法律专题培训</router-link>
          </div>
          <div class="nav-next">
            <span class="nav-label">
              下一篇
              <i class="el-icon-arrow-right"></i>
            </span>
            <router-link to="/news/detail/3">公司开展2026年"安全生产月"活动</router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mockNewsDetail, mockNews } from '@/api/mock'

export default {
  name: 'NewsDetail',
  data() {
    return {
      newsDetail: mockNewsDetail,
      relatedNews: mockNews.slice(1, 4)
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail-header {
  position: relative;
  height: 420px;
  overflow: hidden;
}

.news-detail-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.news-detail-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.88) 0%, rgba(30, 41, 59, 0.7) 100%);
}

.news-detail-title {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
}

.news-detail-category-badge {
  display: inline-block;
  padding: 6px 20px;
  background: linear-gradient(135deg, #1a56db, #4f46e5);
  color: white;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  margin-bottom: 25px;
}

.news-detail-title h1 {
  font-size: 38px;
  font-weight: 700;
  color: white;
  margin-bottom: 25px;
  max-width: 800px;
  line-height: 1.4;
}

.news-detail-meta {
  display: flex;
  align-items: center;
  gap: 15px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 15px;

  .meta-item {
    display: flex;
    align-items: center;
    gap: 6px;

    i {
      font-size: 14px;
    }
  }

  .meta-divider {
    color: rgba(255, 255, 255, 0.3);
  }
}

.news-detail-layout {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 40px;
}

.news-detail-article {
  background: white;
  border-radius: 20px;
  padding: 50px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.06);
}

.news-detail-image {
  margin-bottom: 40px;
  border-radius: 16px;
  overflow: hidden;

  img {
    width: 100%;
    height: 420px;
    object-fit: cover;
  }
}

.news-detail-text {
  p {
    font-size: 16px;
    color: #475569;
    line-height: 2;
    margin-bottom: 25px;
  }

  .first-paragraph {
    font-size: 17px;
    color: #334155;
    font-weight: 500;
  }
}

.news-detail-quote {
  position: relative;
  margin: 35px 0;
  padding: 30px 35px 30px 70px;
  background: linear-gradient(135deg, rgba(26, 86, 219, 0.05), rgba(79, 70, 229, 0.05));
  border-left: 4px solid #1a56db;
  border-radius: 0 16px 16px 0;
  font-style: italic;
  font-size: 16px;
  color: #475569;
  line-height: 1.9;

  .quote-icon {
    position: absolute;
    left: 28px;
    top: 32px;
    font-size: 24px;
    color: #1a56db;
  }

  .quote-author {
    display: block;
    margin-top: 15px;
    font-size: 14px;
    color: #94a3b8;
    font-style: normal;
  }
}

.news-detail-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #f1f5f9;

  .tags-label {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
  }

  .tag-item {
    padding: 6px 16px;
    background: #f1f5f9;
    color: #64748b;
    font-size: 13px;
    border-radius: 20px;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      background: rgba(26, 86, 219, 0.1);
      color: #1a56db;
    }
  }
}

.news-detail-actions {
  margin-top: 30px;
  padding-top: 25px;
  border-top: 1px solid #f1f5f9;
}

.share-section {
  display: flex;
  align-items: center;
  gap: 12px;

  .share-label {
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
  }
}

.share-btn {
  width: 42px;
  height: 42px;
  border: none;
  background: #f1f5f9;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  i {
    font-size: 18px;
    color: #64748b;
  }

  &:hover {
    background: linear-gradient(135deg, #1a56db, #4f46e5);
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(26, 86, 219, 0.3);

    i {
      color: white;
    }
  }
}

.news-detail-sidebar {
  .sidebar-section {
    background: white;
    border-radius: 16px;
    padding: 28px;
    margin-bottom: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: #1e293b;
      margin-bottom: 24px;
      padding-bottom: 14px;
      border-bottom: 2px solid #f1f5f9;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 40px;
        height: 2px;
        background: linear-gradient(135deg, #1a56db, #4f46e5);
      }
    }
  }
}

.related-news-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 18px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      display: flex;
      gap: 12px;
      text-decoration: none;
      padding: 10px;
      border-radius: 10px;
      transition: all 0.3s ease;

      &:hover {
        background: #f8fafc;

        .related-news-title {
          color: #1a56db;
        }
      }

      img {
        width: 80px;
        height: 60px;
        object-fit: cover;
        border-radius: 10px;
        flex-shrink: 0;
      }

      .related-news-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
      }

      .related-news-title {
        font-size: 14px;
        color: #1e293b;
        line-height: 1.4;
        margin-bottom: 6px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        transition: color 0.3s ease;
      }

      .related-news-date {
        font-size: 12px;
        color: #94a3b8;
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          font-size: 12px;
        }
      }
    }
  }
}

.contact-section {
  text-align: center;

  .contact-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 10px 0;
    color: #64748b;
    font-size: 14px;

    i {
      color: #1a56db;
      font-size: 18px;
    }
  }

  .contact-btn {
    display: inline-block;
    margin-top: 15px;
    padding: 10px 30px;
    background: linear-gradient(135deg, #1a56db, #4f46e5);
    color: white;
    text-decoration: none;
    border-radius: 25px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 5px 20px rgba(26, 86, 219, 0.3);
      transform: translateY(-2px);
    }
  }
}

.news-detail-navigation {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  margin-top: 40px;
}

.nav-prev,
.nav-next {
  flex: 1;
  background: white;
  padding: 25px 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  }
}

.nav-prev {
  border-left: 3px solid #1a56db;
}

.nav-next {
  text-align: right;
  border-right: 3px solid #1a56db;
}

.nav-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #94a3b8;
  margin-bottom: 10px;

  i {
    font-size: 12px;
  }
}

.nav-prev a,
.nav-next a {
  font-size: 15px;
  color: #334155;
  text-decoration: none;
  transition: color 0.3s ease;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  &:hover {
    color: #1a56db;
  }
}

@media (max-width: 992px) {
  .news-detail-layout {
    grid-template-columns: 1fr;
  }

  .news-detail-title h1 {
    font-size: 30px;
  }
}

@media (max-width: 768px) {
  .news-detail-header {
    height: 320px;
  }

  .news-detail-title h1 {
    font-size: 24px;
  }

  .news-detail-meta {
    flex-wrap: wrap;
    gap: 10px;
    font-size: 13px;
  }

  .news-detail-article {
    padding: 25px;
  }

  .news-detail-image img {
    height: 260px;
  }

  .news-detail-navigation {
    flex-direction: column;
    gap: 15px;
  }

  .nav-next {
    text-align: left;
    border-right: none;
    border-left: 3px solid #1a56db;
  }
}
</style>
